<div id="content" *ngIf="showError == true">
  <img style="width: 100%;height: 100%;"
    src="https://cdn.dribbble.com/userupload/7810185/file/original-8f452ad55930b88289eb616a3bc6996a.jpg">
</div>

<mat-progress-spinner style="margin:0 auto;height: 100%;" color="primary" mode="indeterminate" value="50"
  *ngIf="showLoadingSpinner == true && showError == false">
</mat-progress-spinner>

<div *ngIf="showLoadingSpinner == false && showError == false" class="my-dialog position-relative" >
  <div mat-dialog-title style="box-shadow: 0px 4px 4px -2px rgba(0, 0, 0, 0.5);" class="d-flex justify-content-between align-items-center pt-2 mt-1 px-2">
    <h3 class="d-inline-block title-mi">Descargar documento electronico:</h3>
  </div>
  <div mat-dialog-content>
    <div class="container">
      <b>{{ this.Id }}</b>
    </div>
  </div>
  <div mat-dialog-actions style="text-align: center !important; margin: auto; max-width: 400px !important;" class="d-flex justify-content-around">
    <button style="margin-top: 5px !important;" mat-button class="btn btn-secondary" cdkFocusInitial
      (click)="procesarComprobantePDF()">Descargar PDF</button>
    <button style="margin-top: 5px !important;" mat-button class="btn btn-secondary" cdkFocusInitial
      (click)="procesarComprobanteXML()">Descargar XML</button>
  </div>

  <div class="btn-flotante position-absolute" >
    <button style="margin-top: 5px !important;" mat-button class="mi-btn" cdkFocusInitial
      (click)="cerrarDialog()">X</button>
  </div>

</div>
